import RatingEdit from './RatingEdit';

export default RatingEdit;
